import { useParams } from "react-router-dom";

import { useFolderBreadcrumbs } from "@/components/ui/Breadcrumbs/hooks";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { useFolders } from "@/queries";

const useFolderPathBreadcrumbs = (currentFolderId: number | null, currentPageName?: string) => {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const authContext = useAuth();
  const userContext = useUser();
  const { userToken } = authContext!;
  const workspaceIdNumber = userContext.activeWorkspaceId!;

  const foldersQuery = useFolders(userToken!, workspaceIdNumber!);

  const breadcrumbItems = useFolderBreadcrumbs(
    foldersQuery.data?.folders || [],
    currentFolderId,
    workspaceId,
    !currentPageName, // Folder is only current page if there's no item being viewed
  );

  // Add current page name if provided
  const items = currentPageName
    ? [...breadcrumbItems, { label: currentPageName, id: null }]
    : breadcrumbItems;

  return {
    items,
    showBackButton: !!currentFolderId,
    ariaLabel: "Registry navigation",
  };
};

export default useFolderPathBreadcrumbs;
